import axios from 'axios';
import {
  GetTestimonialResponse,
  UpdateTestimonialResponse,
  GetTestimonialRespondentResponse,
  TagTestimonialResponseResponse,
} from '~/types/api/testimonials';
import { TaggableResourceType } from '~/types/models/tags';

import { testimonialApiPath } from './testimonialActions';

export interface FetchTestimonialArgs {
  testimonialUuid: string;
}
export async function fetchTestimonial({
  testimonialUuid,
}: FetchTestimonialArgs) {
  const res = await axios.get<GetTestimonialResponse>(
    `${testimonialApiPath}/${testimonialUuid}`
  );
  return res.data;
}

export interface MarkRespondentAsViewedArgs {
  testimonialUuid: string;
  respondentUuid: string;
}
export async function markRespondentAsViewed({
  testimonialUuid,
  respondentUuid,
}: MarkRespondentAsViewedArgs) {
  const res = await axios.post<UpdateTestimonialResponse>(
    `${testimonialApiPath}/${testimonialUuid}/respondents/${respondentUuid}`,
    {
      viewed: true,
      _method: 'PUT',
    }
  );
  return res.data;
}
export interface RespondentApiArgs {
  testimonialUuid: string;
  respondentUuid: string;
}

export async function fetchRespondent({
  testimonialUuid,
  respondentUuid,
}: RespondentApiArgs) {
  const res = await axios.get<GetTestimonialRespondentResponse>(
    `${testimonialApiPath}/${testimonialUuid}/respondents/${respondentUuid}`
  );

  return res.data;
}

export async function deleteRespondent({
  testimonialUuid,
  respondentUuid,
}: RespondentApiArgs) {
  const res = await axios.delete(
    `${testimonialApiPath}/${testimonialUuid}/respondents/${respondentUuid}`
  );

  return res.data;
}

export async function updateRespondentConsent({
  testimonialUuid,
  respondentUuid,
  hasConsent,
}: RespondentApiArgs & { hasConsent: boolean }) {
  const res = await axios.post<{ message: string }>(
    `${testimonialApiPath}/${testimonialUuid}/respondents/${respondentUuid}/consent`,
    {
      has_consent: hasConsent,
    }
  );

  return res.data;
}

export type TagResourceArgs = {
  resourceType: TaggableResourceType;
  resourceUuid: string;
  tagUuid: string;
};
export async function tagResource({
  resourceUuid,
  tagUuid,
  resourceType,
}: TagResourceArgs): Promise<TagTestimonialResponseResponse> {
  const res = await axios.post<TagTestimonialResponseResponse>(
    '/api/v3/resource/tags',
    {
      tag_uuid: tagUuid,
      resource_uuid: resourceUuid,
      resource_type: resourceType,
    }
  );

  return res.data;
}

export type UntagResourceArgs = {
  resourceTagUuid: string;
};
export async function untagResource({
  resourceTagUuid,
}: UntagResourceArgs): Promise<TagTestimonialResponseResponse> {
  const res = await axios.delete<TagTestimonialResponseResponse>(
    `/api/v3/resource/tags/${resourceTagUuid}`
  );

  return res.data;
}
